import { RichTextValue } from '@/components';
import { formatters } from '@/core';
import { useGetTermsAndConditionsVersionQuery } from '@/redux/termsAndConditions';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
}

export function TermsAndConditionsDetailsPanel(props: Props) {
  const { id } = props;
  const { t } = useTranslation();

  const { data, isFetching } = useGetTermsAndConditionsVersionQuery(
    { id: id },
    { skip: !id },
  );

  if (!data || isFetching) {
    return null;
  }

  return (
    <>
      <Alert
        className="mb-4"
        type="info"
        description={t('termsAndConditions.info', {
          version: data.version,
          updatedAt: formatters.dateTime(data.createdAt),
        })}
      />

      <RichTextValue
        label={false}
        value={data.content}
        ownerType="TermsAndConditions"
        ownerId={''}
      />
    </>
  );
}
